import Header from "@ui/internal/components/header";
import Sidebar from "@ui/internal/components/sidebar";
import { ArrowRight } from "lucide-react";
import React, { useState } from "react";
type Props = { [key: string]: any };

const index: React.FC<Props> = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <>
      <div className="flex  bg-[#F7FFFC]">
        <div
          className={`p-[30px] duration-400 z-40  transition-all max-md:absolute ${
            showSidebar
              ? "max-md:block translate-x-0"
              : " max-md:-translate-x-[300px]"
          }`}
        >
          <Sidebar setShowSidebar={setShowSidebar} />
          <span
            onClick={() => setShowSidebar(!showSidebar)}
            className={`absolute top-1/2 transition-all max-md:flex hidden cursor-pointer -right-10 ${
              showSidebar ? "right-10" : "-right-[20px]"
            } size-[40px] flex justify-center items-center z-40 ${
              showSidebar
                ? "rotate-180 text-[#1A926C] bg-white border "
                : "bg-[#1DA077] text-white"
            }  rounded-full  -translate-x-1/2 `}
          >
            <ArrowRight />
          </span>
        </div>

        <div className="w-full max-md:p-4 max-h-[100vh] overflow-y-auto">
          <div className="py-[30px] max-md:py-0  flex flex-col max-md:gap-y-4 gap-y-[32px]">
            <Header />
            <div className=" bg-white shadow-sm rounded-[10px] lg:p-[30px]">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
